import { useNavigate } from "react-router-dom";
import { Table } from "src/components/organisms/Table";
import {
  jobNumberColumn,
  tickerColumn,
  typeColumn,
  recordDateStartColumn,
  recordDateEndColumn,
  stageColumn,
} from "src/components/organisms/Table/columns";
import { ClassActionEventResult } from "src/store/globalSearch/types";

interface Props {
  classActionEvents: ClassActionEventResult[];
  closeSearchDrawer: () => void;
}

export const SearchClassActionResults = ({
  classActionEvents,
  closeSearchDrawer,
}: Props) => {
  const navigate = useNavigate();

  if (classActionEvents.length === 0) {
    return null;
  }

  return (
    <Table
      data={classActionEvents}
      columns={[
        jobNumberColumn,
        tickerColumn,
        typeColumn,
        recordDateStartColumn,
        recordDateEndColumn,
        stageColumn,
      ]}
      rowOnClick={(event) => {
        navigate(`/class-action-events/${event.id}/details`);
        closeSearchDrawer();
      }}
    />
  );
};
